import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/financial-documents/unit/:unitId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    unitId: string;
}
const mutationFn = ({ unitId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { unitId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteUnit };
